<template>
  <div>
    INFORMAÇÕES:
    <br />
    O envio de mensagem automática será realizado todo mês, na hora e no dia
    configurados.
    <br />
    Já a mensagem manual poderá ser enviada uma vez ao dia.
    <br />
    <br />

    <div class="actions-section">
      Números vinculados: {{ linkedNumbers.length }}/1
      <v-btn
        v-if="
          linkedNumbers.length == 0 &&
          permission('write', 'whatsapp_report_medicine')
        "
        class="btn-add-modern mb-5"
        @click="handleCreate()"
      >
        <i class="fas fa-plus mr-2"></i>
        <span>Adicionar Número</span>
      </v-btn>
    </div>

    <div class="table-section">
      <div class="table-card">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <v-data-table
            :headers="headers"
            :items="linkedNumbers"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            class="modern-table"
            :no-data-text="'Nenhum agendamento encontrado'"
            :loading-text="'Carregando agendamentos...'"
          >
            <template v-slot:[`item.automatic_data_hours`]="{ item }">
              <div v-if="item.day">
                <span>Todo Dia: {{ item.day }}</span>
                <br />
                <span>Ás: {{ item.hours }}</span>
              </div>

              <div v-else>
                <span>Manual</span>
              </div>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                v-if="permission('edit', 'whatsapp_report_medicine')"
                small
                class="btn-edit-modern m-1"
                @click="handleUpdate(item.id)"
              >
                <i class="fas fa-edit mr-1"></i>
                Editar
              </v-btn>

              <v-btn
                small
                v-if="!item.automatic"
                class="btn-edit-modern m-1"
                @click="sendManualMessage(item.id)"
              >
                <i class="fas fa-envelope mr-1"></i>
                Mandar Mensagem manual
              </v-btn>

              <!-- teste -->
              <v-btn
                small
                v-if="false && item.automatic"
                class="btn-edit-modern m-1"
                @click="sendAutomaticMessage(item.id)"
              >
                <i class="fas fa-vial mr-1"></i>
                TESTAR Mensagem automática
              </v-btn>
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>

    <BindPhoneNumber
      :resident_id="resident_id"
      :type="type"
      @create="getWhatsappResidentPeople"
    />

    <EditPhoneNumber
      :resident_id="resident_id"
      :type="type"
      :whatsapp_resident_people_id="whatsapp_resident_people_id"
      @update="getWhatsappResidentPeople"
    />
  </div>
</template>

<script>
import BindPhoneNumber from "./BindPhoneNumber";

import EditPhoneNumber from "./EditPhoneNumber";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

import permission from "../../lib/permission";

export default {
  name: "ListPhoneNumber",

  components: {
    BindPhoneNumber,
    EditPhoneNumber,
  },

  props: {
    resident_id: Number,
    type: String,
  },

  data() {
    return {
      loading: false,

      whatsapp_resident_people_id: 0,

      linkedNumbers: [],

      headers: [
        {
          text: "Nome",
          value: "name",
        },
        {
          text: "Número",
          value: "phone_number",
        },
        {
          text: "Mensagem automática",
          value: "automatic_data_hours",
        },
        {
          text: "Ações",
          value: "action",
        },
      ],
    };
  },

  async created() {
    await this.getWhatsappResidentPeople();
  },

  watch: {
    resident_id() {
      this.getWhatsappResidentPeople();
    },
  },

  methods: {
    permission,

    async getWhatsappResidentPeople() {
      try {
        this.loading = true;

        let { resident_id, type } = this;

        let params = { resident_id, type };

        const response = await api.get("/whatsapp-resident", { params });

        const { linkedNumbers } = response.data;

        this.linkedNumbers = linkedNumbers;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async sendManualMessage(whatsapp_resident_people_id) {
      try {
        this.loading = true;

        let { resident_id, type } = this;

        let params = { whatsapp_resident_people_id, resident_id, type };

        const response = await api.post(
          "/whatsapp-resident/send-manual-message",
          params
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async sendAutomaticMessage() {
      try {
        await api.post("/whatsapp-resident/test-send-automatic-message");
      } catch (error) {
        console.error(error);
      }
    },

    handleCreate() {
      let { resident_id, type } = this;

      this.$nextTick(() => {
        this.$bvModal.show("bindPhoneNumber-" + type + "-" + resident_id);
      });
    },

    handleUpdate(whatsapp_resident_people_id) {
      this.whatsapp_resident_people_id = whatsapp_resident_people_id;

      this.$nextTick(() => {
        this.$bvModal.show("EditPhoneNumber-" + whatsapp_resident_people_id);
      });
    },
  },
};
</script>

<style scoped>
.btn-edit-modern {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.25) !important;
  transition: all 0.3s ease !important;
}

.btn-edit-modern:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.35) !important;
}

.menu-folder-modern {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0;
}

/* Header Section */
.folders-header {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.title-section {
  flex: 1;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
  font-size: 20px;
}

.section-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 14px;
}

.actions-section {
  display: flex;
  gap: 12px;
}

/* Modern Button */
.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  margin-left: auto !important;
  display: block !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

/* Content Section */
.folder-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Folder Sections */
.folder-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.section-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  flex: 1;
}

.section-icon {
  color: #0f65b0;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.folder-count {
  background: #0f65b0;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

.section-content {
  padding: 24px;
}

/* No Results State */
.no-results-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 48px 24px;
}

.no-results-content {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}

.no-results-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  border: 2px solid #e5e7eb;
}

.no-results-icon i {
  font-size: 32px;
  color: #94a3b8;
}

.no-results-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.no-results-text {
  color: #64748b;
  font-size: 14px;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.no-results-suggestion {
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.suggestion-text {
  color: #374151;
  font-size: 14px;
  margin: 0 0 16px 0;
  font-weight: 500;
}

.btn-create-suggestion {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-create-suggestion:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .folder-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 20px;
  }

  .header-content {
    text-align: center;
  }

  .folder-title {
    font-size: 20px;
    justify-content: center;
  }

  .section-header {
    padding: 16px 20px;
  }

  .section-content {
    padding: 20px;
  }

  .no-results-card {
    padding: 32px 20px;
  }

  .no-results-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }

  .no-results-icon i {
    font-size: 24px;
  }

  .no-results-title {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .menu-folder-modern {
    gap: 16px;
  }

  .folder-header {
    padding: 16px;
  }

  .folder-title {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
  }

  .folder-subtitle {
    font-size: 13px;
  }

  .section-title {
    gap: 8px;
  }

  .section-title h3 {
    font-size: 14px;
  }

  .folder-count {
    font-size: 11px;
    padding: 3px 8px;
  }

  .btn-add-modern,
  .btn-create-suggestion {
    padding: 10px 20px !important;
    font-size: 14px !important;
  }

  .no-results-title {
    font-size: 16px;
  }

  .no-results-text,
  .suggestion-text {
    font-size: 13px;
  }
}

/* Animation for smooth transitions */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.folder-section {
  animation: slideIn 0.3s ease forwards;
}

.folder-section:nth-child(1) {
  animation-delay: 0.1s;
}

.folder-section:nth-child(2) {
  animation-delay: 0.2s;
}
</style>